// Pure mapping from the query params that devise_token_auth appends to the
// auth_origin_url (Microsoft SSO redirect) into the header shape that
// `saveAdminAuthToken` (src/api/index.js) consumes.
//
// NOTE: devise_token_auth returns `auth_token` (not `token`) and `client_id`
// (not `client`) on the redirect — this mapping is the single source of truth
// for that translation.

export interface EntraCallbackParams {
  auth_token?: string | null;
  client_id?: string | null;
  uid?: string | null;
  expiry?: string | null;
  config?: string | null;
  error?: string | null;
}

export interface AdminAuthHeaders {
  'access-token': string;
  client: string;
  uid: string;
  expiry: string;
}

export const mapEntraParamsToAdminHeaders = (
  params: EntraCallbackParams
): AdminAuthHeaders | null => {
  if (!params.auth_token) return null;

  return {
    'access-token': params.auth_token,
    client: params.client_id ?? '',
    uid: params.uid ?? '',
    expiry: params.expiry ?? '',
  };
};

// Parse a query string (e.g. window.location.search) into EntraCallbackParams.
export const parseEntraCallbackParams = (search: string): EntraCallbackParams => {
  const sp = new URLSearchParams(search);
  return {
    auth_token: sp.get('auth_token'),
    client_id: sp.get('client_id'),
    uid: sp.get('uid'),
    expiry: sp.get('expiry'),
    config: sp.get('config'),
    error: sp.get('error'),
  };
};
